import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { fetchStudentStats } from '../utils/api';
import './Reports.css';
import './_Buttons.css';

const ReportsStats = () => {
    const [reportType, setReportType] = useState('students-by-statuses');
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState('');
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleFetchReport = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setReportData(null);

        try {
            let response;
            if (reportType === 'students-by-statuses' || reportType === 'students-by-types') {
                response = await fetchStudentStats(year, month);
            }
            setReportData(response.data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const renderChart = () => {
        if (!reportData) {
            return null;
        }

        const data = reportData.map(item => {
            const date = new Date(item.date + 'T00:00:00');
            const monthName = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
            return {
                ...item,
                name: month ? date.getUTCDate() : monthName,
            };
        });

        const statusKeys = {
            'students': { name: 'Students', color: '#8884d8' },
            'students-by-statuses': {
                'prospective': { name: 'Prospective', color: '#82ca9d' },
                'applicants': { name: 'Applicants', color: '#ffc658' },
                'students': { name: 'Students', color: '#8884d8' },
                'graduated': { name: 'Graduated', color: '#ff8042' },
                'cancelled': { name: 'Cancelled', color: '#e0e0e0' }
            },
            'students-by-types': {
                'initial': { name: 'Initial', color: '#8884d8' },
                'transfer': { name: 'Transfer', color: '#82ca9d' },
                'cos': { name: 'COS', color: '#ffc658' },
                'not_f1': { name: 'Not F1', color: '#ff8042' }
            }
        };

        const lines = reportType === 'students-by-statuses'
            ? Object.keys(statusKeys['students-by-statuses']).map(key => (
                <Line key={key} type="monotone" dataKey={`statuses.${key}`} stroke={statusKeys['students-by-statuses'][key].color} name={statusKeys['students-by-statuses'][key].name} />
            ))
            : reportType === 'students-by-types'
                ? Object.keys(statusKeys['students-by-types']).map(key => (
                    <Line key={key} type="monotone" dataKey={`types.${key}`} stroke={statusKeys['students-by-types'][key].color} name={statusKeys['students-by-types'][key].name} />
                ))
                : <Line type="monotone" dataKey="statuses.students" stroke={statusKeys['students'].color} name={statusKeys['students'].name} />;

        return (
            <ResponsiveContainer width="100%" height={400}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    {lines}
                </LineChart>
            </ResponsiveContainer>
        );
    };

    const renderReport = () => {
        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error: {error}</div>;
        }

        return renderChart();
    };

    return (
        <div className="invoices-container">
            <div className="header">
                <h1>Stats Reports</h1>
            </div>
            <form onSubmit={handleFetchReport}>
                <div className="reports-filters">
                    <div className='invoices-labels'>
                        <label>Report Type:
                            <select className="reports-select" value={reportType} onChange={(e) => { setReportType(e.target.value); setReportData(null); }}>
                                <option value="students-by-statuses">Students by Statuses</option>
                                <option value="students-by-types">Students by Types</option>
                            </select>
                        </label>
                        <div>
                            <label>Year: <input className='label-input' type="number" value={year} onChange={(e) => setYear(e.target.value)} required /></label><br></br>
                            <label>Month:
                                <select className="reports-select" value={month} onChange={(e) => setMonth(e.target.value)}>
                                    <option value="">All</option>
                                    <option value="1">Jan</option>
                                    <option value="2">Feb</option>
                                    <option value="3">Mar</option>
                                    <option value="4">Apr</option>
                                    <option value="5">May</option>
                                    <option value="6">Jun</option>
                                    <option value="7">Jul</option>
                                    <option value="8">Aug</option>
                                    <option value="9">Sep</option>
                                    <option value="10">Oct</option>
                                    <option value="11">Nov</option>
                                    <option value="12">Dec</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <button type="submit" className='submit-button text-button'>Generate Report</button>
                </div>
            </form>
            <div className="report-content">
                {renderReport()}
            </div>
        </div>
    );
};

export default ReportsStats;
